import React, { useEffect, useState } from "react";
import { fetchAPI } from "@/utility/NetworkUtils";

const NavbarShoppingCart = ({
  user
}) => {
  const [cartNumber, setCartNumber] = useState(null);
  
  useEffect(() => {
    fetchCart()
    window.addEventListener("addToCart", (e) => {
      setCartNumber( cartNumber + e.detail.quantity)
    })
  },[])

  const fetchCart = () => {
    fetchAPI(`/webapi/cart_item_quantity`, (json)=> {
      if (!json.errors) {
        setCartNumber(json.cart_item_quantity)
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {});
  }
  
  if (user && user.id !== null) {
    return (
      <div className="shopping-cart-container">
        <a href={`/orders/new`}>
          <img src="/images/paw-light.png"/>
          <div className="shopping-cart-quantity">{cartNumber}</div>
        </a>
      </div>
    )
  }
}

export default NavbarShoppingCart